import React from 'react';
import { useField, useFormikContext } from 'formik';
import { Autocomplete, Box, Button, ListItemText, MenuItem, TextField, Typography } from '@mui/material';
import { Settings } from '@mui/icons-material';
// This component abstracts the Autocomplete to be used with Formik
const CustomAutoComplete = React.forwardRef(({ formik, name, options, setTransporterOpen, required, label, disabled }, ref) => {
  console.log(options, 'options');

  return (
    <>
      <Autocomplete
        id={name}
        options={options}
        getOptionLabel={(option) => option.label || ''}
        value={options.find((option) => option.value?.toUpperCase() === formik.values[name]?.toUpperCase()) || null}
        onFocus={() => formik.setFieldTouched([name], true)}
        onChange={(_, newValue) => {
          if (name !== 'tname') {
            formik.setFieldTouched([name], true);
            formik.setFieldValue([name], newValue ? newValue.value : '');
          } else {
            formik.setFieldTouched([name], true);
            formik.setFieldValue([name], newValue ? newValue.value : '');
            formik.setFieldValue('tObj', newValue ? newValue : '');
          }
        }}
        disabled={disabled}
        size="small"
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            sx={{
              '.MuiFormLabel-asterisk': {
                color: 'danger.main',
                fontSize: '20px',
                fontWeight: 'bold',
              },
            }}
            inputRef={ref}
            required={formik.errors[name] && !formik.values[name]}
            error={formik.touched[name] && formik.errors[name]}

            // error={meta.touched && Boolean(meta.error)}
            // helperText={meta.touched && meta.error}
          />
        )}
        renderOption={(props, option) => {
          if (option.value == 'gg') {
            return (
              <Box
                sx={{
                  boxShadow: '0px -4px 10px -2px rgba(0, 0, 0, 0.2)',
                  width: '100%',
                  position: 'fixed',
                  bottom: '-25px',
                  zIndex: '1000',
                  background: 'white',
                }}
              >
                <MenuItem sx={{ whiteSpace: 'nowrap' }} onClick={() => setTransporterOpen(true)}>
                  <Settings fontSize="small" sx={{ marginRight: '5px' }} />
                  <ListItemText primary={' Add Transporter'} />
                </MenuItem>
              </Box>
            );
          } else {
            return (
              <MenuItem
                {...props}
                key={option.value}
                // onClick={() => {
                //   if (option.value === "add_new") {
                //     handleAddNew();
                //   }
                // }}
              >
                {option.label}
              </MenuItem>
            );
          }
        }}
      />
      {formik.touched[name] && formik.errors[name] ? (
        <Typography variant="body1" className="error" style={{ fontSize: '13px' }}>
          {formik.errors[name]}
        </Typography>
      ) : (
        <p style={{ padding: '12px' }}></p>
      )}
    </>
  );
});

export default CustomAutoComplete;
